import { Close } from "@mui/icons-material";
import { Box, Fade, IconButton, Modal, Paper, useTheme } from "@mui/material";
import PropTypes from "prop-types";

import React from "react";

function StelModal(props) {
  const { open, onClose, title = "", width, children, ...rest } = props;
  const theme = useTheme();

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        maxWidth: 1000,
        margin: "auto",
      }}
      style={{ width }}
      aria-labelledby="simple-modal-title"
      {...rest}
    >
      <Fade in={open}>
        <Paper
          sx={{
            boxShadow: theme.shadows[5],
            outline: "none",
            width: "100%",
            padding: "15px",
            position: "relative",
            borderRadius: "2px",
            height: "auto",
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <Box
              sx={{
                fontSize: "18px",
                fontWeight: 500,
                color: theme.palette.text.primary,
                textTransform: "capitalize",
              }}
            >
              {title}
            </Box>
            <IconButton
              onClick={onClose}
              sx={{
                position: "absolute",
                top: "5px",
                right: "5px",
                padding: "8px",
                zIndex: 2,
                "& svg": {
                  fontSize: "25px",
                },
              }}
              size="large"
            >
              <Close />
            </IconButton>
          </Box>
          {children}
        </Paper>
      </Fade>
    </Modal>
  );
}

StelModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  width: PropTypes.number.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
    .isRequired,
};

export default StelModal;
